import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9829d96e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9829d96e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9829d96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9829d96e')) {
      api.createRecord('9829d96e', component.options)
    } else {
      api.reload('9829d96e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9829d96e&scoped=true", function () {
      api.rerender('9829d96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/questionnaireExamine/index.vue"
export default component.exports